<template>
    <div class="timer custom-timer">
        {{ timeRemaining.days }} <span>D</span>:
        {{ timeRemaining.hours }} <span>H</span>:
        {{ timeRemaining.minutes }} <span>M</span>:
        {{ timeRemaining.seconds }} <span>S</span>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'TimerView',

    props: {
        timer: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            timerId: null,
            timeRemaining: {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00'
            }
        };
    },

    created() {
        this.startTimer();
    },

    beforeDestroy() {
        this.clearTimer();
    },

    methods: {
        startTimer() {
            // Initial calculation
            this.calculateTime();

            // Update every second
            this.timerId = setInterval(() => {
                this.calculateTime();
            }, 1000);
        },

        clearTimer() {
            if (this.timerId) {
                clearInterval(this.timerId);
                this.timerId = null;
            }
        },

        isContestActive() {
            const now = new Date();
            const startDate = new Date(this.timer.start_date);
            const endDate = new Date(this.timer.end_date);

            return now >= startDate && now <= endDate;
        },

        calculateTime() {
            const now = moment();
            const endDate = this.isContestActive() ? moment(this.timer.end_date) : moment(this.timer.start_date);

            // If contest has ended
            if (now.isAfter(endDate)) {
                this.timeRemaining = {
                    days: '00',
                    hours: '00',
                    minutes: '00',
                    seconds: '00'
                };
                this.clearTimer();
                return;
            }

            const duration = moment.duration(endDate.diff(now));

            this.timeRemaining = {
                days: this.padNumber(Math.floor(duration.asDays())),
                hours: this.padNumber(duration.hours()),
                minutes: this.padNumber(duration.minutes()),
                seconds: this.padNumber(duration.seconds())
            };
        },

        padNumber(number) {
            return Math.max(0, number).toString().padStart(2, '0');
        }
    }
};
</script>